import { Injectable } from '@angular/core';
import { Security } from '../security/security.service';

@Injectable()
export class DbService {
  constructor(private security: Security) {}

  async updateObject(obj: any): Promise<any> {
    let result = await this.security.post('api/Db/UpdateObject', obj);
    return result;
  }
}
